import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import get from 'lodash/get';

import MobileNavbar from '../common/MobileNavbar';

import { BREAKPOINT } from '../../constants/styles';
import { POST_TITLE } from '../../constants/strings';
import { currentCommunityInfoSelector } from '../../redux/communities/selectors/currentCommunity';
import Avatar from '../Avatar';

const MobileNavigation = ({
  intl: { formatMessage },
  params: { postId },
  currentCommunityInfo,
  toggleContext,
  showHeader,
}) => {
  const communityTitle = get(currentCommunityInfo, 'name');
  const communityUrl = get(currentCommunityInfo, 'logo[url]');
  const postTitle = postId && formatMessage(POST_TITLE);

  return (
    <MediaQuery maxWidth={BREAKPOINT}>
      <MobileNavbar openContext="arrow-down" toggleContext={toggleContext}>
        {showHeader && (
          <Fragment>
            <Avatar
              children={communityTitle}
              src={communityUrl}
              bordered
              position="center"
              size={30}
            />
            <p className="ml2 f-14" children={postTitle || communityTitle} />
          </Fragment>
        )}
      </MobileNavbar>
    </MediaQuery>
  );
};

MobileNavigation.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  params: PropTypes.shape({
    communityId: PropTypes.string,
    postId: PropTypes.string,
  }).isRequired,
  currentCommunityInfo: PropTypes.object,
  showHeader: PropTypes.bool,
  toggleContext: PropTypes.func,
};

MobileNavigation.defaultProps = {
  currentCommunityInfo: null,
  showHeader: false,
  toggleContext: null,
};

const mapStateToProps = state => ({
  currentCommunityInfo: currentCommunityInfoSelector(state),
});

export default injectIntl(
  withRouter(connect(mapStateToProps)(MobileNavigation)),
);



// WEBPACK FOOTER //
// ./src/components/Communities/MobileNavigation.jsx